import { thunk } from 'easy-peasy';

import { toPhotoFileName } from '~/utils/file';
import api from '~/services/api';
import { IThunkAddClient } from '../types';

const onAddClient: IThunkAddClient = thunk(async (_, { requestInfo, requestPayload }) => {
  const photo = await toPhotoFileName(requestPayload.photo);
  const { data } = await api.client.addClient(requestInfo, { ...requestPayload, photo });

  return data;
});

export default onAddClient;
